document.querySelectorAll('[data-rbpb]').forEach((root) => {
  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => [...root.querySelectorAll(selector)];
  const mainImage = $('[data-rbpb-main]');
  const thumbs = $$('[data-rbpb-thumb]');
  const counter = $('[data-rbpb-count]');
  const price = $('[data-rbpb-price]');
  const stock = $('[data-rbpb-stock]');
  const submit = $('[data-rbpb-submit]');
  const submitLabel = $('[data-rbpb-submit-label]');
  const quantity = $('[data-rbpb-quantity]');
  const bundleButton = $('[data-rbpb-bundle-add]');
  const bundleTotal = $('[data-rbpb-bundle-total]');
  const bundleMainPrice = $('[data-rbpb-bundle-main-price]');
  const bundleStatus = $('[data-rbpb-bundle-status]');
  const currency = root.dataset.currency || 'USD';
  const whiteValue = (root.dataset.whiteValue || 'white').toLowerCase();
  let galleryIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

  const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
  const selectedVariant = () => $('[data-rbpb-variant]:checked') || $('[data-rbpb-variant]');

  function showImage(index) {
    if (!thumbs.length || !mainImage) return;
    galleryIndex = (index + thumbs.length) % thumbs.length;
    const thumb = thumbs[galleryIndex];
    mainImage.src = thumb.dataset.image;
    mainImage.alt = thumb.dataset.alt || '';
    thumbs.forEach((item, itemIndex) => {
      const active = itemIndex === galleryIndex;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-current', String(active));
    });
    if (counter) counter.textContent = `${galleryIndex + 1} / ${thumbs.length}`;
  }

  function updateDetailImages(variantTitle) {
    const useWhite = (variantTitle || '').toLowerCase().includes(whiteValue);
    $$('[data-rbpb-detail]').forEach((picture) => {
      const desktop = useWhite && picture.dataset.whiteDesktop ? picture.dataset.whiteDesktop : picture.dataset.defaultDesktop;
      const mobile = useWhite && picture.dataset.whiteMobile ? picture.dataset.whiteMobile : picture.dataset.defaultMobile;
      const desktopImage = picture.querySelector('[data-rbpb-desktop]');
      const mobileSource = picture.querySelector('[data-rbpb-mobile]');
      if (desktopImage && desktop) desktopImage.src = desktop;
      if (mobileSource && mobile) mobileSource.srcset = mobile;
    });
  }

  function updateBundle() {
    if (!bundleTotal) return;
    const variant = selectedVariant();
    const main = Number(variant?.dataset.cents || 0);
    const addons = $$('[data-rbpb-addon]:checked').reduce((sum, input) => sum + Number(input.dataset.cents || 0), 0);
    bundleTotal.textContent = money(main + addons);
    if (bundleMainPrice) bundleMainPrice.textContent = money(main);
    if (bundleButton) bundleButton.disabled = addons === 0 || variant?.dataset.available !== 'true';
  }

  function updateVariant(input) {
    const available = input.dataset.available === 'true';
    if (price) price.textContent = input.dataset.price;
    if (stock) {
      stock.textContent = available ? stock.dataset.available : stock.dataset.soldout;
      stock.classList.toggle('is-available', available);
    }
    if (submit) submit.disabled = !available;
    if (submitLabel) submitLabel.textContent = available ? submitLabel.dataset.available : submitLabel.dataset.soldout;
    if (input.dataset.image && mainImage) {
      const match = thumbs.findIndex((thumb) => thumb.dataset.image === input.dataset.image);
      if (match >= 0) showImage(match); else mainImage.src = input.dataset.image;
    }
    updateDetailImages(input.dataset.title);
    updateBundle();
  }

  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
  $('[data-rbpb-prev]')?.addEventListener('click', () => showImage(galleryIndex - 1));
  $('[data-rbpb-next]')?.addEventListener('click', () => showImage(galleryIndex + 1));
  $$('[data-rbpb-variant]').forEach((input) => input.addEventListener('change', () => updateVariant(input)));
  $('[data-rbpb-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
  $('[data-rbpb-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });
  $$('[data-rbpb-addon]').forEach((input) => input.addEventListener('change', updateBundle));

  bundleButton?.addEventListener('click', async () => {
    const variant = selectedVariant();
    const addons = $$('[data-rbpb-addon]:checked');
    if (!variant || !addons.length) return;
    const items = [{ id: Number(variant.value), quantity: Math.max(1, Number(quantity?.value || 1)) }, ...addons.map((input) => ({ id: Number(input.value), quantity: 1 }))];
    bundleButton.disabled = true;
    bundleButton.setAttribute('aria-busy', 'true');
    if (bundleStatus) bundleStatus.textContent = 'Adding selected items…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('Unable to add the selected items. Please review availability and try again.');
      window.location.assign(root.dataset.cartUrl || '/cart');
    } catch (error) {
      if (bundleStatus) bundleStatus.textContent = error.message;
      bundleButton.disabled = false;
      bundleButton.removeAttribute('aria-busy');
    }
  });

  if (thumbs.length) showImage(galleryIndex);
  updateDetailImages(selectedVariant()?.dataset.title);
  updateBundle();
});
